// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, put } from '../../../../common/api'
import { ADD_ACTIVITY, LIST_ACTIVITY, GET_ACTIVITY } from '../../../../common/constant'

export const actionActivities = createAsyncThunk('appActivities/actionActivities', async (params, thunkAPI) => {
    return await post(LIST_ACTIVITY, params, thunkAPI)
})

export const actionAddActivities = createAsyncThunk('appActivities/actionAddActivities', async (params, thunkAPI) => {
    return await put(ADD_ACTIVITY, params, thunkAPI)
})

export const actionGetActivities = createAsyncThunk('appActivities/actionGetActivities', async (params, thunkAPI) => {
    return await post(GET_ACTIVITY, params, thunkAPI)
})

// export const actionEditActivities = createAsyncThunk('appActivities/actionEditActivities', async (params, thunkAPI) => {
//     return await post(ADD_ACTIVITY, params, thunkAPI)
// })

// export const actionDeleteActivities = createAsyncThunk('appActivities/actionDeleteActivities', async (params, thunkAPI) => {
//     return await post(ADD_ACTIVITY, params, thunkAPI)
// })

export const appActivitiesSlice = createSlice({
    name: 'appActivities',
    initialState: {
        //list
        loading: false,
        activities: null,

        //add
        loadingAdd: false,
        addActivities: null,

        //get
        loadingGet: false,
        getActivities: null

        // //edit
        // loadingEdit: false,
        // editActivities: null,

        // //delete
        // loadingDelete: false,
        // deleteActivities: null

    },
    reducers: {
        //reset or delete Add Activities store data
        resetActivitiesResponse: (state) => {
            state.activities = null
        },
        resetAddActivitiesResponse: (state) => {
            state.addActivities = null
        },
        resetGetActivitiesResponse: (state) => {
            state.getActivities = null
        }
        // resetEditActivitiesResponse: (state) => {
        //     state.editActivities = null
        // },
        // resetDeleteActivitiesResponse: (state) => {
        //     state.deleteActivities = null
        // }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionActivities.pending, (state) => {
                state.loading = true
            })
            .addCase(actionActivities.fulfilled, (state, action) => {
                state.loading = false
                state.activities = action.payload
            })
            .addCase(actionActivities.rejected, (state) => {
                state.loading = false
            })

            //add
            .addCase(actionAddActivities.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddActivities.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addActivities = action.payload
            })
            .addCase(actionAddActivities.rejected, (state) => {
                state.loadingAdd = false
            })

            //get
            .addCase(actionGetActivities.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetActivities.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getActivities = action.payload
            })
            .addCase(actionGetActivities.rejected, (state) => {
                state.loadingGet = false
            })

        //edit
        // .addCase(actionEditActivities.pending, (state) => {
        //     state.loadingEdit = true
        // })
        // .addCase(actionEditActivities.fulfilled, (state, action) => {
        //     state.loadingEdit = false
        //     state.editActivities = action.payload
        // })
        // .addCase(actionEditActivities.rejected, (state) => {
        //     state.loadingEdit = false
        // })

        //delete
        // .addCase(actionDeleteActivities.pending, (state) => {
        //     state.loadingDelete = true
        // })
        // .addCase(actionDeleteActivities.fulfilled, (state, action) => {
        //     state.loadingDelete = false
        //     state.deleteActivities = action.payload
        // })
        // .addCase(actionDeleteActivities.rejected, (state) => {
        //     state.loadingDelete = false
        // })
    }
})
export const { resetActivitiesResponse, resetAddActivitiesResponse, resetGetActivitiesResponse } = appActivitiesSlice.actions

export default appActivitiesSlice.reducer